"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _GenericErrorPage["default"];
  }
});
var _GenericErrorPage = _interopRequireDefault(require("./GenericErrorPage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }